/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NewCallAliases {
  AUTOCOMPLETE_TYPE = 'autocomplete-type',
  CARD_CALL_OPENING = 'card-call-opening',
  CONTEXTUAL_BAR_1 = 'contextual-bar-1',
  ESTADO_CIVIL_MAPPER = 'estado-civil-mapper',
  FETCH_GUIDANCE = 'fetch-guidance',
  FETCH_PROVIDERS = 'fetch-providers',
  FETCH_TERM = 'fetch-term',
  FETCH_TYPE_OF_CALL = 'fetch-type-of-call',
  FIELD_CALL_TYPE = 'field-call-type',
  FIELD_DS_DETAILING = 'field-dsDetailing',
  FIELD_DS_SUBJECT = 'field-dsSubject',
  FIELD_GUIDANCE = 'field-guidance',
  FIELD_PROVIDER = 'field-provider',
  FIELD_REQUIRED_ATTACHMENT = 'field-required-attachment',
  FIELD_RESPONSABILITY_TERM = 'field-responsability-term',
  FIELD_TERM = 'field-term',
  FIELD_TERM_SEQUENCE = 'field-term-sequence',
  FIELD_UPLOADER = 'field-uploader',
  FILE_UPLOADER_0 = 'file-uploader-0',
  FORM_0 = 'form-0',
  FORM_NEW_CALL = 'form-new-call',
  HPMS_TERM_RESPONSABILITY_CHECKBOX = 'hpms-term-responsability-checkbox',
  HPMS_TEXT_HTML_0 = 'hpms-text-html-0',
  INPUT_2 = 'input-2',
  LAYOUT_NEW_CALL = 'layout-new-call',
  MAPPER_0 = 'mapper-0',
  MAPPER_PROVIDER = 'mapper-provider',
  MODAL_RESPONSABILITY_TERM = 'modal-responsability-term',
  PANEL_0 = 'panel-0',
  PANEL_2 = 'panel-2',
  PANEL_3 = 'panel-3',
  PANEL_CALL_OPENING = 'panel-call-opening',
  PANEL_NEW_CALL = 'panel-new-call',
  PANEL_RESPONSABILITY_TERM = 'panel-responsability-term',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_GUIDANCE = 'text-guidance',
  TEXT_PROVIDER = 'text-provider',
  UNBOXED_AUTOCOMPLETE_PROVIDER = 'unboxed-autocomplete-provider',
}
export { NewCallAliases };
